import styled from 'styled-components';
import { ActionMenu } from 'ui/actionMenu';

export const StyledActionMenu = styled(ActionMenu)`
  [data-test='action-menu-options'] {
    width: 100%;
  }
`;
